module.exports = __webpack_public_path__ + "img/smile-wink.55849571.svg";